import { render, staticRenderFns } from "./ImgUploadDetail.vue?vue&type=template&id=0c2c24fb&scoped=true"
import script from "./ImgUploadDetail.vue?vue&type=script&lang=js"
export * from "./ImgUploadDetail.vue?vue&type=script&lang=js"
import style0 from "./ImgUploadDetail.vue?vue&type=style&index=0&id=0c2c24fb&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2c24fb",
  null
  
)

export default component.exports